import template from './views/teacherView.html';
import './profileSetting.scss';
import controller from './controllers/teacherViewController';


const name = 'teacherView';
var module = angular.module("app.teacherView", [
    'ui.router'
]).component(name, {
    template: template,
    controllerAs: name,
    controller: controller
}).controller('teacherViewCtrl', controller);


/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('teacherView', {
            parent: 'app',
            url: '/teacherView',
            views: {
                '@': {
                    template: navigationTpl,
                    controller: navigationCtrl,
                    controllerAs: 'teacherView'
                }
            }
        })
}); */

export default module;


// WEBPACK FOOTER //
// ./src/app/profileSetting/teacherViewModule.js